const latLngToCoordinates = function (latLng, decPlaces = 6) {
  if (!latLng || !latLng.lat || !latLng.lng) return null
  return {
    latitude: Number(latLng.lat.toFixed(decPlaces)),
    longitude: Number(latLng.lng.toFixed(decPlaces)),
  }
}
export default latLngToCoordinates
